import { UserDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { UserDetailsActions } from './actions/user-details.actions';
import { CreateOrEditUserModal } from './actions/edit-user/edit-user-action.component';
import { useUserDetails } from './hooks/use-user-details.hook';
import { AddNoteActionModal } from '../../../ui/components/higher-order/add-note-action/add-note-modal.component';
import { KnownNoteEntityTypes } from '../../../ui/components/higher-order/add-note-action/add-note.hook';
import { EditCapabilitiesActionComponent } from './actions/edit-capabilities/edit-capabilities-action.component';

type UseUserDetailsResult = ReturnType<typeof useUserDetails>;
export type Actions = UseUserDetailsResult['actions'];

export function UserDetailsActionsObserver({
  actions,
  user,
  projectID
}: {
  actions: Actions;
  user?: UserDto;
  projectID: string;
}) {
  switch (actions.currentAction) {
    case UserDetailsActions.EDIT_GROUP_MEMBER:
      return (
        <CreateOrEditUserModal
          userDto={user}
          projectID={projectID}
          onSuccess={() => actions.setAction(UserDetailsActions.EDIT_GROUP_MEMBER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case UserDetailsActions.EDIT_GROUP_MEMBER_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The user details have been updated
        </Snackbar>
      );
    case UserDetailsActions.EDIT_CAPABILITIES:
      return (
        <EditCapabilitiesActionComponent
          onAbort={() => actions.setAction(null)}
          onSuccess={() => actions.setAction(UserDetailsActions.EDIT_CAPABILITIES_SUCCESS)}
          userDto={user}
          projectID={projectID}
        />
      );
    case UserDetailsActions.STATUS_CHANGE_ERROR:
      return (
        <Snackbar severity="error" onClose={() => actions.setAction(null)}>
          There was an error updating the team member
        </Snackbar>
      );
    case UserDetailsActions.STATUS_CHANGE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The team member's status has been changed
        </Snackbar>
      );
    case UserDetailsActions.ADD_NOTE:
      return (
        <AddNoteActionModal
          id={user?.id ?? ''}
          projectID={projectID}
          onSuccess={() => actions.setAction(UserDetailsActions.ADD_NOTE_SUCCESS)}
          onAbort={() => actions.setAction(null)}
          entityType={KnownNoteEntityTypes.User}
        />
      );
    case UserDetailsActions.ADD_NOTE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Note added
        </Snackbar>
      );
    default:
      return null;
  }
}
